<script>

	import Button from "../../ui/Button.svelte";

	import { session } from '../../lib/stores.js';

	import {	showDate } from '../../lib/dt.js';
	import { autoblur } from '../../lib/autoblur.js';

</script>

<style>

	div {
		margin: 1rem;
	}

	h2 {
		font-weight: 700;
		font-style: normal;
		font-size: 1.3rem;
		line-height: 1.2;
		margin-bottom: 0.3rem;
		color: var(--textColor);
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;  
		overflow: hidden;
	}
	.times {
		display: flex;
		align-items: center;
		position: relative;
		top: 0.1rem;
		color: var(--textColor);
	}
	.times svg {
		width: 0.8em;
		height: 0.8em;
		margin-right: 0.5em;
	}
	.times span {
		font-weight: 400;
		font-style: normal;
		font-size: 0.8rem;;
	}

</style>

<div>
	<h2>{$session.name}</h2>

	<p class="times">
		<svg viewBox="0 0 48.1 48.1"><path d="M24.1 48.1c-13.3 0-24.1-10.8-24.1-24 0-13.3 10.8-24.1 24.1-24.1s24.1 10.8 24.1 24.1-10.9 24-24.1 24zm0-44.1c-11.1 0-20.1 9-20.1 20.1s9 20.1 20.1 20.1 20.1-9 20.1-20.1-9.1-20.1-20.1-20.1zM32.6 22.5h-6.5v-11.6c0-1.1-.9-2-2-2s-2 .9-2 2v13.5c0 1.1.9 2 2 2h8.5c1.1 0 2-.9 2-2s-.9-1.9-2-1.9z"/></svg>
		<span>{showDate($session.starts, 'dddd DD, HH:mm')}–{showDate($session.ends, 'HH:mm')}</span>
	</p>
</div>